import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";

@Pipe({ name: "tciDate" })
export class NgTCIDatePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) { }

  transform(value: number): string {
    if (value) {
      const ngDate = this.datePipe.transform(value, "dd MMM y h:mm");
      const period = this.datePipe.transform(value, "a").toLowerCase();
      return `${ngDate} ${period}`;
    } else {
      return "";
    }
  }
}
